import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import bankBalancesService from './bankBalancesService.js';

export const getBankBalances = createAsyncThunk('admin/bank-balances', async (_, { rejectWithValue }) => {
  try {
    const response = await bankBalancesService.get();
    return response;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return rejectWithValue(message);
  }
});

const initialState = {
  balances: {},
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: ''
};

export const bankBalancesSlice = createSlice({
  name: 'adminBankBalances',
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankBalances.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBankBalances.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.balances = action.payload;
      })
      .addCase(getBankBalances.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  }
})

export const { reset } = bankBalancesSlice.actions;
export default bankBalancesSlice.reducer; 